import React from "react";
import { isEmpty } from "lodash";

import styles from "./login.module.scss";

type EmailWelcomeProps = {
	domains: string[];
};

const EmailWelcome = ({ domains = [] }: EmailWelcomeProps) => {
	const isEmptyDomains: boolean = isEmpty(domains);
	const provideMessage = `Please provide a unique email address${
		isEmptyDomains ? "." : "meeting your agent office domain requirement:"
	} `;
	return (
		<div>
			<div className={styles.emailWelcomeHolder}>
				<h6>We noticed your email is shared.</h6>
				<h6>{provideMessage}</h6>
			</div>
			{!isEmptyDomains && (
				<div className={styles.domainList}>{domains?.join(", ")}</div>
			)}
		</div>
	);
};

export { EmailWelcome };
